module.exports = __webpack_public_path__ + "img/image-10.d36e6e61.webp";